export default "__VITE_ASSET__7e4af025__"